import { EmailField, type EmailResult } from '@vp/contact-channels'
import { Box } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactDetailsFields } from '../../../hooks/use-contact-details'

interface ContactEmailFieldProps {
  control: Control<ContactDetailsFields>
}

export const ContactEmailField = ({ control }: ContactEmailFieldProps) => {
  const { t } = useTranslation()

  return (
    <Box data-testid="email-field">
      <Controller
        name="email"
        control={control}
        rules={{ required: true, validate: (v: EmailResult) => v.isValid }}
        render={({ field }) => (
          <EmailField
            {...field}
            required
            validateOnChange
            textInputProps={{ defaultValue: field.value.email }}
            label={t('contact_us.page.steps.details.fields.email_label')}
            inputGroupProps={{ style: { width: '100%' }, mb: undefined }}
          />
        )}
      />
    </Box>
  )
}
